import { FC, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { Center } from "components/layout/reusableLayouts";
import LoadingWithoutModal from "components/common/LoadingWithoutModal";
import registry from "./registry";
import { CheckoutProps } from "./types";

const AcquirerCheckout: FC<CheckoutProps> = (props) => {
  const { t } = useTranslation();
  const Checkout = registry[props.session.acquirer];

  if (!Checkout) {
    return (
      // It always renders inside a host card, so it is the card's text, not another card.
      <Center sx={{ paddingBlock: "var(--space-6)" }}>
        <Typography
          variant="body1"
          sx={{ color: "var(--color-text-primary)", textAlign: "center" }}
        >
          {t("checkout.UnavailableMessage")}
        </Typography>
      </Center>
    );
  }

  return (
    <Suspense fallback={<LoadingWithoutModal open />}>
      <Checkout {...props} />
    </Suspense>
  );
};

export default AcquirerCheckout;
